import { getLabelFromStorage } from '@pb/utils'

export const GIFT_CARD_ERROR_MESSAGES = {
  '00': 'checkout.giftcard.check.zero.value',
  '02': 'checkout.giftcard.check.expired',
  '03': 'checkout.giftcard.check.number.invalid',
  '08': 'checkout.giftcard.check.number.invalid',
  '16': 'checkout.giftcard.check.expired',
  '20': 'checkout.giftcard.check.pin.nomatch',
  '33': 'checkout.giftcard.check.expired',
  duplicate: 'checkout.giftcard.check.already.added',
  systemError: 'checkout.giftcard.check.system.unavailable',
  MAXIMUM_GIFT_CARDS_REACHED: 'cart.giftcard.maximum',
} as const

export const GIFT_CARD_ERROR_AS_INFO_MESSAGE = {
  '00': true,
  '02': true,
  '03': false,
  '08': false,
  '16': true,
  '20': false,
  '33': true,
  duplicate: true,
  systemError: false,
} as const

export const GIFT_CARD_LABELS = {
  addGiftCardText: getLabelFromStorage('cart.giftcard.pay.with.giftcard'),
  heading: getLabelFromStorage('cart.giftcard.heading'),
  description: getLabelFromStorage('cart.giftcard.description', {
    replacements: [4, 19],
  }),
  giftCardNumber: getLabelFromStorage('cart.giftcard.cardnumber'),
  pinCode: getLabelFromStorage('cart.giftcard.pincode'),
  pinCodeTooShort: getLabelFromStorage('cart.giftcard.pincode.too.short', {
    replacements: 4,
  }),
  cardNumberTooShort: getLabelFromStorage('cart.giftcard.cardnumber.too.short', {
    replacements: 19,
  }),
  add: getLabelFromStorage('cart.voucher.add'),
  digits: getLabelFromStorage('cart.giftcard.digits'),
  close: getLabelFromStorage('text.button.close'),
  applied: getLabelFromStorage('cart.giftcard.applied'),
  valueDeducted: getLabelFromStorage('cart.giftcard.value.deducted'),
  valueRemaining: getLabelFromStorage('cart.giftcard.value.remaining'),
  removeGiftCard: getLabelFromStorage('cart.giftcard.remove'),
  removed: getLabelFromStorage('cart.giftcard.removed'),
}
